module.exports = __webpack_public_path__ + "img/ignis-gls-plus-azul-sodalita.409f58a7.png";